const categories = [
  "推荐",
  "最新",
  "热门",
  "精选",
  "短片",
  "主播",
  "合集",
  "剧情",
  "自拍",
  "原创",
  "榜单",
  "发现",
  "福利",
];

const cities = [
  "北京",
  "上海",
  "广州",
  "深圳",
  "成都",
  "杭州",
  "重庆",
  "武汉",
  "西安",
  "苏州",
];

const adSource = [
  { position: 2, type: 0, label: "文字", title: "精品专区入口", url: "/detail?id=1" },
  { position: 2, type: 0, label: "文字", title: "热门合集推荐", url: "/detail?id=2" },
  { position: 2, type: 0, label: "文字", title: "VIP 内容推荐", url: "/detail?id=3" },
  { position: 2, type: 0, label: "文字", title: "深夜精选专场", url: "/detail?id=4" },
  { position: 0, type: 1, label: "背景", title: "新片速递专区", url: "/detail?id=5" },
  { position: 0, type: 1, label: "背景", title: "收藏本站不迷路", url: "/detail?id=6" },
  { position: 0, type: 1, label: "背景", title: "榜单爆款推荐", url: "/detail?id=7" },
  { position: 0, type: 1, label: "背景", title: "人气主播合集", url: "/detail?id=8" },
  { position: 1, type: 2, label: "图标", title: "今日热门", url: "/detail?id=9", thumb: "https://dummyimage.com/100x100/2d6156/fff.png&text=热门" },
  { position: 1, type: 2, label: "图标", title: "极速专区", url: "/detail?id=10", thumb: "https://dummyimage.com/100x100/0d55bb/fff.png&text=极速" },
  { position: 1, type: 2, label: "图标", title: "高热更新", url: "/detail?id=11", thumb: "https://dummyimage.com/100x100/c8a300/fff.png&text=更新" },
  { position: 1, type: 2, label: "图标", title: "精品导航", url: "/detail?id=12", thumb: "https://dummyimage.com/100x100/095d1f/fff.png&text=导航" },
  { position: 2, type: 3, label: "模块", title: "午夜推荐位", url: "/detail?id=1", thumb: "https://dummyimage.com/480x150/7a12b0/fff.png&text=Banner+Ad+1" },
  { position: 2, type: 3, label: "模块", title: "会员专区入口", url: "/detail?id=2", thumb: "https://dummyimage.com/480x150/299283/fff.png&text=Banner+Ad+2" },
  { position: 2, type: 0, label: "文字", title: "今日爆款合集", url: "/detail?id=3" },
  { position: 5, type: 1, label: "背景", title: "详情页热门推荐", url: "/detail?id=4" },
  { position: 5, type: 1, label: "背景", title: "看片前先收藏本站", url: "/detail?id=5" },
  { position: 3, type: 2, label: "图标", title: "精彩内容", url: "/detail?id=6", thumb: "https://dummyimage.com/100x100/230042/fff.png&text=精彩" },
  { position: 3, type: 2, label: "图标", title: "正在热播", url: "/detail?id=7", thumb: "https://dummyimage.com/100x100/004db4/fff.png&text=热播" },
  { position: 4, type: 3, label: "模块", title: "同类精品视频推荐", url: "/detail?id=8", thumb: "https://dummyimage.com/480x150/0b681b/fff.png&text=Banner+Ad+3" },
];

const videoSource = [
  ["同城高热精选合集，今晚热门内容速看", "08:32", "1小时前", "1.8万", "精选"],
  ["主播连麦福利视频合集，热度持续上涨", "12:18", "2小时前", "2.4万", "热门"],
  ["午夜短片推荐，节奏紧凑内容直接", "06:40", "今天", "9800", "短片"],
  ["剧情专区人气合集，高清封面推荐", "15:05", "今天", "1.2万", "剧情"],
  ["最新更新福利视频，首页热门上新", "09:12", "3小时前", "1.5万", "最新"],
  ["精选专题合集，附近热播持续更新", "11:26", "今天", "8600", "精选"],
  ["主播专区精选，高清画质收藏推荐", "07:56", "昨天", "2.1万", "主播"],
  ["热门短片合集，一次看够高热内容", "10:03", "昨天", "1.1万", "热门"],
  ["夜间推荐专区，深夜用户最爱榜单", "14:48", "2天前", "9400", "精选"],
  ["精品视频快速入口，首页直达更新区", "05:33", "今天", "1.9万", "推荐"],
  ["合集专区人气内容推荐，适合连续浏览", "18:22", "1天前", "2.8万", "合集"],
  ["精品视频压轴更新，适合反复浏览", "13:17", "3天前", "7300", "推荐"],
];

export const siteData = {
  siteName: "3P影视",
  notice: "请及时收藏本站地址，避免链接失效找不到入口。",
  adPalette: [
    { bg: "#2d6156", text: "#ffffff", tag: "#c8f5eb" },
    { bg: "#0d55bb", text: "#ffffff", tag: "#b9d7ff" },
    { bg: "#c8a300", text: "#111111", tag: "#ffe566" },
    { bg: "#095d1f", text: "#ffffff", tag: "#9ef0b0" },
    { bg: "#7a12b0", text: "#ffffff", tag: "#f8d3ff" },
    { bg: "#299283", text: "#ffffff", tag: "#c9fff4" },
    { bg: "#396355", text: "#ffffff", tag: "#d2fff0" },
    { bg: "#230042", text: "#ffffff", tag: "#e2c7ff" },
    { bg: "#004db4", text: "#ffffff", tag: "#c1dcff" },
    { bg: "#0b681b", text: "#ffffff", tag: "#bbf7c8" },
  ],
  categories,
  cities,
  videos: videoSource.map((item, index) => ({
    id: index + 1,
    title: item[0],
    duration: item[1],
    publishTime: item[2],
    hotValue: item[3],
    badge: item[4],
    category: categories[index % categories.length],
    city: cities[index % cities.length],
  })),
  ads: adSource.map((item, index) => ({
    id: index + 1,
    position: item.position,
    type: item.type,
    label: item.label,
    title: item.title,
    url: item.url,
    thumb: item.thumb || null,
    create_time: 1744214400 + index * 60,
    size: index % 3 === 0 ? "large" : index % 2 === 0 ? "medium" : "small",
  })),
};
